/*
  Lista zyczen - serduszka, licznik w naglowku i pasek komunikatow.

  Nie trzyma zadnego stanu listy: pyta `window.wishlist` i przerysowuje sie na
  zdarzeniu `wishlist:change`, wiec serduszko zapalone w karuzeli rekomendacji
  zapala sie natychmiast takze na karcie tego samego produktu w listingu obok.

  Obsluga jest delegowana z dokumentu, bo karty produktow dokladaja sie pozniej
  (karuzele, edytor motywu, podstrona listy zyczen) i nie da sie ich podlaczyc
  raz na starcie.

  Pasek komunikatow wystawiamy jako `window.wishlistBar`, bo podstrona listy
  zyczen mowi tym samym paskiem o cofnieciu usuniecia i o dodaniu do koszyka.
*/

(() => {
  const TRIGGER = '[data-wishlist-trigger]';
  const COUNTER = '[data-wishlist-count]';
  const ADDED_CLASS = 'wishlist-trigger--added';

  /* ---------- pasek komunikatow ---------- */

  const barNode = () => document.querySelector('[data-wishlist-bar-message]');
  let barTimer = 0;

  const hideBar = () => {
    const bar = barNode();
    if (!bar) return;
    window.clearTimeout(barTimer);
    bar.setAttribute('data-open', 'false');
    bar.hidden = true;
    bar.classList.remove('wishlist-bar--error');
  };

  /*
    Pasek zyje 6 sekund, nie 4: na telefonie stoi w narozniku przy kciuku,
    a klient w tym czasie przewija karuzele wzorow i musi zdazyc go przeczytac.
    Najechanie myszka zatrzymuje odliczanie.
  */
  const LIFETIME = 6000;

  const showBar = ({ text, linkText, linkHref, undo, error } = {}) => {
    const bar = barNode();
    if (!bar) return;
    const textNode = bar.querySelector('[data-wishlist-bar-text]');
    const link = bar.querySelector('[data-wishlist-bar-link]');
    const undoButton = bar.querySelector('[data-wishlist-bar-undo]');

    if (textNode) textNode.textContent = text || '';

    if (link) {
      const hasLink = Boolean(linkText && linkHref);
      link.hidden = !hasLink;
      if (hasLink) {
        link.textContent = linkText;
        link.href = linkHref;
      }
    }

    if (undoButton) {
      undoButton.hidden = typeof undo !== 'function';
      if (typeof undo === 'function') {
        undoButton.textContent = bar.dataset.labelUndo || '';
        undoButton.onclick = () => {
          undo();
          hideBar();
        };
      } else {
        undoButton.onclick = null;
      }
    }

    bar.classList.toggle('wishlist-bar--error', Boolean(error));
    bar.hidden = false;
    bar.setAttribute('data-open', 'true');
    window.clearTimeout(barTimer);
    barTimer = window.setTimeout(hideBar, LIFETIME);
  };

  window.wishlistBar = { show: showBar, hide: hideBar, strings: () => barNode()?.dataset || {} };

  /* ---------- serduszka i licznik ---------- */

  /*
    Na karcie produktu wariant zmienia sie bez przeladowania strony (selecty
    opcji przepisuja ukryte pole `id`), wiec serduszko produktowe czyta wariant
    z formularza, a nie z wlasnego atrybutu. Atrybut zostaje jako zapas.
  */
  const resolveVariant = (element) => {
    const source = element.dataset.wishlistVariantFrom;
    if (source) {
      const field = document.querySelector(source);
      if (field && field.value) return field.value;
    }
    return element.dataset.wishlistVariant || '';
  };

  const readTrigger = (element) => ({
    variantId: resolveVariant(element),
    productId: element.dataset.wishlistProduct,
    handle: element.dataset.wishlistHandle,
  });

  const paintTrigger = (element) => {
    const inList = window.wishlist.has(resolveVariant(element));
    element.classList.toggle(ADDED_CLASS, inList);
    element.setAttribute('aria-pressed', String(inList));
    const label = inList
      ? element.dataset.wishlistLabelRemove
      : element.dataset.wishlistLabelAdd;
    if (label) {
      element.setAttribute('aria-label', label);
      element.setAttribute('title', label);
    }
  };

  /*
    Licznik pokazuje zero, tak jak odznaka koszyka obok. Dwie odznaki w jednym
    naglowku nie moga odpowiadac inaczej na to samo pytanie.
  */
  const paintAll = () => {
    if (!window.wishlist) return;
    document.querySelectorAll(TRIGGER).forEach(paintTrigger);
    const count = window.wishlist.count();
    document.querySelectorAll(COUNTER).forEach((node) => {
      node.textContent = String(count);
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-wishlist-bar-close]')) {
      hideBar();
      return;
    }

    const trigger = event.target.closest(TRIGGER);
    if (!trigger || !window.wishlist) return;
    event.preventDefault();
    const item = readTrigger(trigger);
    if (!item.variantId) return;

    const strings = barNode()?.dataset || {};

    if (window.wishlist.has(item.variantId)) {
      /*
        Zdjecie wzoru z listy zawsze da sie cofnac. Kolejnosc jest wazna: bez
        cofniecia jedno mylne dotkniecie kciukiem kasuje wzor bezpowrotnie,
        bo lista zyje tylko w tej przegladarce.
      */
      if (window.wishlist.remove(item.variantId)) {
        showBar({
          text: strings.textRemoved,
          undo: () => window.wishlist.add(item),
        });
      }
      return;
    }

    if (window.wishlist.add(item)) {
      /*
        Tetniecie serduszka jest jedynym potwierdzeniem widocznym W MIEJSCU
        klikniecia: pasek stoi na dole ekranu, a licznik w naglowku bywa
        przewiniety poza widok, wiec bez tego na dlugim listingu nie ma sygnalu
        pod palcem.
      */
      trigger.classList.remove('wishlist-trigger--pulse');
      // Odczyt wymusza przeliczenie ukladu, bez ktorego klasa dodana z powrotem
      // w tej samej klatce nie odtworzy animacji.
      void trigger.offsetWidth;
      trigger.classList.add('wishlist-trigger--pulse');
      trigger.addEventListener(
        'animationend',
        () => trigger.classList.remove('wishlist-trigger--pulse'),
        { once: true }
      );

      showBar({
        text: strings.textAdded,
        linkText: strings.linkList,
        linkHref: strings.urlList,
      });
    }
  });

  document.addEventListener('wishlist:change', paintAll);

  // Zmiana wariantu na karcie produktu przestawia tozsamosc serduszka.
  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-variant-picker]')) paintAll();
  });

  document.addEventListener('mouseover', (event) => {
    if (event.target.closest('[data-wishlist-bar-message]')) window.clearTimeout(barTimer);
  });

  document.addEventListener('mouseout', (event) => {
    if (!event.target.closest('[data-wishlist-bar-message]')) return;
    window.clearTimeout(barTimer);
    barTimer = window.setTimeout(hideBar, LIFETIME);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  /*
    Karty dokladane po wczytaniu strony (karuzele, kafle listy zyczen pobierane
    z serwera) musza dostac wlasciwy stan serduszka bez czekania na zmiane listy.
    Bez tego kafel na samej liscie zyczen ma PUSTE serce, choc wzor jest na
    liscie - zmiana zaszla przed jego wstawieniem, wiec zdarzenie go nie zastalo.
  */
  new MutationObserver((records) => {
    const needsPaint = records.some((record) =>
      [...record.addedNodes].some(
        (node) =>
          node.nodeType === 1 && (node.matches?.(TRIGGER) || node.querySelector?.(TRIGGER))
      )
    );
    if (needsPaint) paintAll();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Edytor motywu podmienia HTML sekcji bez odswiezenia strony.
  document.addEventListener('shopify:section:load', paintAll);
})();
